import React, { memo, useCallback } from 'react';
import { useTranslation } from 'react-i18next';

import { ListItem, ListItemIcon, ListItemText } from '../../material-ui/List';
import { Summary } from '../../../icons';
import { useSummaryData } from './useSummaryData';
import { useStyles } from './useStyles';

export const SummaryDataAdapter = memo(({ value, selected, onClick, className }) => {
    const { isLegSummaryData, isLegSummaryDataSended } = useSummaryData();
    const { t: translate } = useTranslation();
    const classes = useStyles();

    const handleClick = useCallback(() => onClick(value), [onClick]);

    return (
        <ListItem onClick={handleClick} button={true} selected={selected}>
            <ListItemIcon className={classes.listIcon}>
                <Summary
                    width="24"
                    height="24"
                    className={isLegSummaryData ? (isLegSummaryDataSended ? classes.iconReady : classes.iconWarning) : null}
                />
            </ListItemIcon>
            <ListItemText primary={translate('labels.summaryInfo')} className={className} />
        </ListItem>
    );
});

SummaryDataAdapter.displayName = 'SummaryDataAdapter';
